import 'what-input';
import 'foundation-sites';
import 'slick-carousel';
import { initUtm } from './utm';
import { initBlocks } from './blocks';
import './utility';
import './layout';
import './speakers';
import './register';
import './presentations';
import './exhibitor-resources';
import './media-kit';
import './media-gallery';

const onLoaded = () => {
	initUtm();
	initBlocks();
}

document.addEventListener("DOMContentLoaded", onLoaded);

jQuery(function ($) {
	$(document).foundation();

	function scrollIt(element) {

		let scrollElement = $(element);

		if ( Object.keys(scrollElement).length === 0 ) { return false; }

	  var offset = 0;
	  if ( Foundation.MediaQuery.atLeast('large') ) {
		offset = stickyHeader.offsetHeight;
	  }
	  window.scrollTo({
		'behavior': 'smooth',
		'left': 0,
		'top': scrollElement.offset().top - offset
	  });
	}

	// If jQuery + GF are present, hook GF post-render (fires for each form and on AJAX)
	if (window.jQuery) {
	  window.jQuery(document).on("gform_post_render", function(){ 
	  	initUtm(); 
	  });
	}

	$(document).ready(function() {

		var sampleSocialCarousel = $('.act-sample-social');
		if ( sampleSocialCarousel.length ) {
			$('.carousel-inner', sampleSocialCarousel).slick({
				cssEase: 'ease-out',
				arrows: true,
				prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
				nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
				mobileFirst: true,
				infinite: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				responsive: [
				  {
					breakpoint: 600,
					settings: {
					  slidesToScroll: 2,
					  slidesToShow: 2
					}
				  },
				  {
					breakpoint: 950,
					settings: {
					  slidesToScroll: 3,
					  slidesToShow: 3
					}
				  },
				  {
					breakpoint: 1200,
					settings: {
					  slidesToScroll: 4,
					  slidesToShow: 4
					}
				  }
				]
			});
		}

		$('.slick-news').slick({
		  cssEase: 'ease-out',
		  arrows: true,
		  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
		  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
		  mobileFirst: true,
		  infinite: false,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  responsive: [
			{
			  breakpoint: 475,
			  settings: {
				slidesToScroll: 2,
				slidesToShow: 2
			  }
			},
			{
			  breakpoint: 950,
			  settings: {
				slidesToScroll: 3,
				slidesToShow: 3
			  }
			}
		  ]
		});

		$('.quotes-block').slick({
		  cssEase: 'ease-out',
		  dots: false,
		  mobileFirst: true,
		  infinite: true,
		  autoplay: true,
		  autoplaySpeed: 6000,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  arrows: false,
		  adaptiveHeight: true,
		  responsive: [
			{
			  breakpoint: 512,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				adaptiveHeight: false
			  }
			}
		  ]
		});

		// ALM
		var alm_is_animating = false; // Animating flag
		$('.alm-filter-nav li:first-of-type').addClass('active'); // Set initial active state
		 
		// Btn Click Event
		$('.alm-filter-nav li a').on('click', function(e){    
		  e.preventDefault();  
		  var el = $(this); // Our selected element     
		  
		  if(!el.hasClass('active') && !alm_is_animating){ // Check for active and !alm_is_animating  
			 alm_is_animating = true;
			 el.parents('.act-block').find('.slick-slider').slick('unslick');
			 el.parent().addClass('active').siblings('li').removeClass('active'); // Add active state
			 
			 var data = el.data(), // Get data values from selected menu item
				 transition = 'fade', // 'slide' | 'fade' | null
				 speed = '300'; //in milliseconds
				
			 ajaxloadmore.filter(transition, speed, data); // Run the filter
		  }      
		});
		 
		window.almFilterComplete = function(){      
		  alm_is_animating = false; // clear animating flag
		};

		window.almComplete = function(alm){
		  var almID = alm.id;

		  // ID checks
		  if ( almID == 'alm_vehicles_carousel') {
			var $wrapper = $('.vehicles-carousel');

			$wrapper.find('.act-vehicle').sort(function(a, b) {
				if ( a.dataset.exhibitor > b.dataset.exhibitor ) {
				  return 1;
				} if ( a.dataset.exhibitor < b.dataset.exhibitor ) {
				  return -1;
				}
				return 0;
			})
			.appendTo($wrapper);

			$('.vehicles-carousel:not(.slick-initialized)').slick({
			  cssEase: 'ease-out',
			  arrows: true,
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
			  mobileFirst: true,
			  infinite: false,
			  responsive: [
				{
				  breakpoint: 512,
				  settings: {
					slidesToShow: 3
				  }
				},
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 4
				  }
				},
				{
				  breakpoint: 1440,
				  settings: {
					slidesToShow: 5
				  }
				}
			  ]
			});
		  } else if ( almID == 'alm_collaborators') {
			$('.collaborators-carousel:not(.slick-initialized)').slick({
			  variableWidth: true,
			  cssEase: 'ease-out',
			  arrows: true,
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
			  mobileFirst: true,
			  autoplay: true,
			  autoplaySpeed: 2000
			});
		  } else if ( almID == 'galleries_carousel') {
			$('.gallery-carousel:not(.slick-initialized)').slick({
			  cssEase: 'ease-out',
			  arrows: true,
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
			  infinite: true,
			  variableWidth: true,
			  centerMode: true
			});
		  } else if ( almID == 'speakers_carousel') {
			var $wrapper = $('.speakers-carousel');

			$wrapper.find('.act-speaker').sort(function(a, b) {
				if ( a.dataset.termorder > b.dataset.termorder ) {
				  return 1;
				} if ( a.dataset.termorder < b.dataset.termorder ) {
				  return -1;
				}
				if ( a.dataset.priority > b.dataset.priority ) {
				  return 1;
				} if ( a.dataset.priority < b.dataset.priority ) {
				  return -1;
				}
				if (a.dataset.lastname > b.dataset.lastname) {
				  return 1;
				} if (a.dataset.lastname < b.dataset.lastname) {
				  return -1;
				}
				return 0;
			})
			.appendTo($wrapper);
			$('.speakers-carousel').slick({
			  variableWidth: true,
			  cssEase: 'ease-out',
			  arrows: true,
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
			  mobileFirst: true,
			  infinite: false,
			  responsive: [
				{
				  breakpoint: 0,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: false,
				  }
				},
				{
				  breakpoint: 640,
				  settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					variableWidth: false,
				  }
				},
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 6,
					slidesToScroll: 6,
					variableWidth: false,
				  }
				}
			  ]
			});
		  } else if ( almID == 'alm_sponsors') {

			$(alm.main).find('.sponsors-carousel:not(.slick-initialized)').slick({
			  variableWidth: true,
			  cssEase: 'ease-out',
			  arrows: true,
			  prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
			  nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
			  mobileFirst: true,
			  autoplay: true,
			  autoplaySpeed: 2000,
			  infinite: true
			});

		  }
		}

		$('.act-accordion').each( function() {
			var accordionWrapper = this;
			var accordion = $(accordionWrapper).find('.accordion');
			var expand = $(accordionWrapper).find('.expand');
			var collapse = $(accordionWrapper).find('.collapse');
			var accordionItems = $(accordion).find('.accordion-content');
			expand.click( function() {
				$(accordion).foundation( 'down', accordionItems );
				$(accordionWrapper).addClass('all-expanded');
			});
			collapse.click( function() {
				$(accordion).foundation( 'up', accordionItems );
				$(accordionWrapper).removeClass('all-expanded');
			});
		});		

	});
	$(window).load(function() {
		$(document).on( 'gform_post_render', function( event, formId, currentPage ) {
			scrollIt('#gform_confirmation_wrapper_' + formId);
		});
	});
});